import "./assets/styles.css";
import {
	isRouteErrorResponse,
	Links,
	Meta,
	Outlet,
	Scripts,
	ScrollRestoration,
	useLoaderData,
} from "react-router";
import { SpritesheetsProvider } from "./src/context/SpritesheetsContext";

export async function loader() {
	const { CharacterRepository, ContributorRepository, SpritesheetRepository } =
		await import("./repositories.server");

	const allSheets = await SpritesheetRepository.getAllSpritesheets();
	const allCharacters = CharacterRepository.getAllCharacters();
	const allContributors = ContributorRepository.getAllContributors();
	return { allSheets, allCharacters, allContributors };
}

export function Layout({ children }: { children: React.ReactNode }) {
	return (
		<html lang="en">
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<link rel="preconnect" href="https://fonts.googleapis.com" />
				<link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
				<link href="https://fonts.googleapis.com/css2?family=VT323&display=swap" rel="stylesheet" />
				<Meta />
				<Links />
				<script
					dangerouslySetInnerHTML={{
						__html: `
              window.__reactRouterContext && window.__reactRouterContext.routeDiscovery && (
                window.__reactRouterContext.routeDiscovery.manifestPath = window.__reactRouterContext.basename.replace(/\\/$/, '') + "/__manifest"
              )
            `,
					}}
				/>
			</head>

			<script async src="https://scripts.simpleanalyticscdn.com/latest.js"></script>

			<body>
				{children}
				<ScrollRestoration />
				<Scripts />
			</body>
		</html>
	);
}

export default function App() {
	const data = useLoaderData<typeof loader>();

	return (
		<SpritesheetsProvider
			data={data.allSheets}
			characters={data.allCharacters}
			contributors={data.allContributors}
		>
			<Outlet />
		</SpritesheetsProvider>
	);
}

export function ErrorBoundary({ error }: { error: unknown }) {
	let message = "Oops!";
	let details = "An unexpected error occurred.";
	let stack: string | undefined;

	if (isRouteErrorResponse(error)) {
		message = error.status === 404 ? "404" : "Error";
		details =
			error.status === 404 ? "The requested page could not be found." : error.statusText || details;
	} else if (import.meta.env.DEV && error && error instanceof Error) {
		details = error.message;
		stack = error.stack;
	}

	return (
		<main className="pt-16 p-4 container mx-auto">
			<h1>{message}</h1>
			<p>{details}</p>
			{stack && (
				<pre className="w-full p-4 overflow-x-auto">
					<code>{stack}</code>
				</pre>
			)}
		</main>
	);
}
